import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getDebitNoteList = createAsyncThunk(
  "get-debit-note",
  async ({id, data}, { dispatch }) => {
    try {
      const response = await axios.get(`bill-debit/list/${id}`, { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createDebitNote = createAsyncThunk(
  "create-debit-note",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("bill-debit", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getByIdDebitNote = createAsyncThunk(
  "edit-debit-note",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`bill-debit/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateDebitNote = createAsyncThunk(
  "update-debit-note",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/bill-debit/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteDebitNote = createAsyncThunk(
  "delete-debit-note",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/bill-debit/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const debitNoteSlice = createSlice({
  name: "debitNote",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDebitNoteList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDebitNoteList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.billDebitList?? [];
        state.perPage = action?.payload?.data?.data?.perPage?? 1;
        state.total = action?.payload?.data?.data?.total?? 0;
      })
      .addCase(getDebitNoteList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default debitNoteSlice.reducer;
